import * as PIXI from 'pixi.js';
import { IPoint } from 'framework/utils/math-utils';

// @ts-ignore
PIXI.Point.prototype.distanceTo = function (point: IPoint) {
  const dx: number = point.x - this.x;
  const dy: number = point.y - this.y;

  return Math.sqrt(dx * dx + dy * dy);
};

// @ts-ignore
PIXI.Point.prototype.rotationTo = function (point: IPoint) {
  const dx: number = point.x - this.x;
  const dy: number = point.y - this.y;

  return Math.atan2(dy, dx);
};

// @ts-ignore
PIXI.Point.prototype.dot = function (point: IPoint) {
  return this.x * point.x + this.y * point.y;
};

// @ts-ignore
PIXI.Point.prototype.cross = function (point: IPoint) {
  return this.x * point.y - this.y * point.x;
};
